module.exports = __webpack_public_path__ + "img/logo_login.98ae3dd3.png";